export class APIError {
  static format = (value: any, fieldName: string) => {
    if (value && value[fieldName] && value[fieldName].msg) {
      return value[fieldName].msg;
    } else if (value && value.error && value.error[fieldName]) {
      return value.error[fieldName].msg;
    } else if (
      value &&
      value.response &&
      value.response.data &&
      value.response.data.error &&
      value.response.data.error[fieldName]
    ) {
      return value.response.data.error[fieldName].msg;
    }

    return "";
  };
}
